import { render } from "./Docs.vue?vue&type=template&id=2ff159ee&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2ff159ee"

export default script